<div class="wrapper-modal">
  <div class="wrapper-modal-content delete">
    <div class="wrapper-modal-image">
      <img src="../../../../../assets/icons/outline/icon-delete.svg" alt="">
    </div>
    <div class="modal-title">{{deleteChatText.title | translate}}</div>
    <div class="modal-description">{{deleteChatText.description | translate}}</div>
    <div class="modal-buttons">
      <button class="custom-btn custom-btn--outline-red" (click)="closeDeleteChatModal.emit()">
        <span>{{'GENERAL.cancel' | translate}}</span>
      </button>
      <button class="custom-btn custom-btn--delete" (click)="takeAction()">
        <span>{{deleteChatText.buttonText | translate}}</span>
      </button>
    </div>
  </div>
</div>
